import {
  ACTOR_COMPLAINT_REASON_LABELS,
  TActorComplaintReason
} from '@/shared/constants';

/**
 * Подпись причины жалобы; неизвестный код показывается как есть
 * @param code - код причины
 */
export const getActorComplaintReasonLabel = (code: string) =>
  ACTOR_COMPLAINT_REASON_LABELS[code as TActorComplaintReason] ?? code;

/**
 * «Причины» дела в списке: подписи через запятую, число — только если больше одного
 * («Чужие фото ×3, Спам или реклама»). Общий для жалоб на анкеты и на участников
 * @param summary - `reasons_summary` бэка: `[{ reason, count }]`
 * @param getLabel - подпись причины по коду (по умолчанию — причины жалобы на анкету)
 */
export const formatActorComplaintReasonsSummary = (
  summary: unknown,
  getLabel: (code: string) => string = getActorComplaintReasonLabel
): string => {
  if (!Array.isArray(summary)) return '—';

  const parts = summary.flatMap(item => {
    if (!item || typeof item !== 'object') return [];

    const { reason, count } = item as { reason?: unknown; count?: unknown };

    if (typeof reason !== 'string') return [];

    const label = getLabel(reason);

    return [
      typeof count === 'number' && count > 1 ? `${label} ×${count}` : label
    ];
  });

  return parts.length ? parts.join(', ') : '—';
};

/**
 * Причины одной жалобы: подписи через запятую
 * @param reasons - массив кодов
 */
export const formatActorComplaintReasons = (reasons: unknown): string => {
  if (!Array.isArray(reasons)) return '—';

  const labels = reasons
    .filter((code): code is string => typeof code === 'string')
    .map(getActorComplaintReasonLabel);

  return labels.length ? labels.join(', ') : '—';
};
